import { FC, useLayoutEffect, useState } from 'react';
import Cookies from 'js-cookie'


import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

import './HeatMapChart.scss';

type HeatMapChartProps = {
    name: string,
    data?: any[],
    xAxisLabels?: any[],
    yAxisLabels?: any[],
    xAxisFieldName: string,
    titleX: string,
    yAxisFieldName: string,
    titleY: string,
    valueFieldName: string,
    height?: any,
    width?: any,
    handleClick?: (a: any) => void;
};

const HeatMapChart: FC<HeatMapChartProps> = ({ name, data, xAxisLabels, yAxisLabels, xAxisFieldName, titleX, yAxisFieldName, titleY, valueFieldName, height, width, handleClick }) => {
    const nameId = name + Date.now().toString().substr(-4);
    const [tempHeatMap, setTempHeatMap] = useState<any>();

    useLayoutEffect(() => {
        if (data && !tempHeatMap && xAxisLabels && yAxisLabels && data.length && xAxisLabels.length && yAxisLabels.length) {
            am5.ready(function () {
                var root = am5.Root.new(nameId);
                setTempHeatMap(root);
                root.setThemes([am5themes_Animated.new(root)]);
                const globalFontSize = Number(Cookies.get('globalFontSize'))*0.9||12
                var chart = root.container.children.push(
                    am5xy.XYChart.new(root, {
                        panX: false,
                        panY: false,
                        wheelX: 'none',
                        wheelY: 'none',
                        layout: root.verticalLayout
                    }),
                );

                var yRenderer = am5xy.AxisRendererY.new(root, { minGridDistance: Number(Cookies.get('globalFontSize')) * 4.4 || 30 });


                var yAxis = chart.yAxes.push(
                    am5xy.CategoryAxis.new(root, {
                        maxDeviation: 0,
                        renderer: yRenderer,
                        categoryField: yAxisFieldName,
                    }),
                );

                //yAxis.children.unshift(
                //    am5.Label.new(root, {
                //        rotation: -90,
                //        text: titleY,
                //        fill: am5.color(0x003b5c),
                //        fontWeight: "600",
                //        fontStyle: "italic",
                //        y: am5.p50,
                //        centerX: am5.p50
                //    })
                //);

                var xRenderer = am5xy.AxisRendererX.new(root, { opposite: true, minGridDistance: Number(Cookies.get('globalFontSize')) * 4.4 || 30 });


                var xAxis = chart.xAxes.push(
                    am5xy.CategoryAxis.new(root, {
                        renderer: xRenderer,
                        categoryField: xAxisFieldName,
                    }),
                );
                //xAxis.children.unshift(
                //    am5.Label.new(root, {
                //        text: titleX,
                //        fill: am5.color(0x003b5c),
                //        fontWeight: "600",
                //        fontStyle: "italic",
                //        x: am5.p50,
                //        centerX: am5.p50
                //    })
                //);

                var series = chart.series.push(
                    am5xy.ColumnSeries.new(root, {
                        calculateAggregates: true,
                        stroke: am5.color(0xf0f8ff),
                        clustered: false,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        categoryXField: xAxisFieldName,
                        categoryYField: yAxisFieldName,
                        valueField: valueFieldName,
                        background: am5.Rectangle.new(root, {
                            fill: am5.color(0xd9d9d9),
                            stroke: am5.color(0xd9d9d9),
                            fillOpacity: .5
                        })
                    }),
                );

                series.columns.template.setAll({
                    tooltipText: '{value}',
                    strokeOpacity: 1,
                    strokeWidth: 1,
                    width: am5.percent(100),
                    height: Number(Cookies.get('globalFontSize')) * 4.4 || am5.percent(100),
                    stroke: am5.color(0xffffff),
                    cornerRadiusTL: 5,
                    cornerRadiusTR: 5,
                    cornerRadiusBL: 5,
                    cornerRadiusBR: 5,
                });


                series.columns.template.events.on("click", function (event) {
                    const selectedSquare: any = event?.target?.dataItem?.dataContext
                    if (selectedSquare && handleClick) {
                        handleClick(selectedSquare)
                    }
                });

                series.set('heatRules', [
                    {
                        target: series.columns.template,
                        min: am5.color(0xaebec7),
                        max: am5.color(0x043c5b),
                        dataField: 'value',
                        key: 'fill',
                    },
                ]);

                let heatLegend = chart.bottomAxesContainer.children.push(
                    am5.HeatLegend.new(root, {
                        orientation: 'horizontal',
                        startColor: am5.color(0xaebec7),
                        endColor: am5.color(0x043c5b),
                    }),
                );
                series.events.on('datavalidated', function () {
                    heatLegend.set('endValue', series.getPrivate('valueHigh'));
                    heatLegend.set('startValue', series.getPrivate('valueLow'));
                });
                series.columns.template.events.on('pointerover', function (event) {
                    var di = event.target.dataItem;

                    if (di) {
                        // @ts-ignore
                        heatLegend.showValue(di.get('value', 0));
                    }
                })


                if (Cookies.get('darkMode') === "true") {
                    xRenderer.labels.template.setAll({
                        fill: am5.color(0xffffff),
                        oversizedBehavior: "wrap",
                        maxWidth: 150, fontSize: globalFontSize<16?globalFontSize:16,
                        textAlign: "center"
                    });
                    yRenderer.labels.template.setAll({
                        fill: am5.color(0xffffff),
                        oversizedBehavior: "wrap",
                        maxWidth: 150, fontSize: globalFontSize<16?globalFontSize:16,
                        textAlign: "right"
                    });

                } else {
                    xRenderer.labels.template.setAll({
                        fill: am5.color(0x043c5b),
                        oversizedBehavior: "wrap",
                        maxWidth: 150, fontSize: globalFontSize<16?globalFontSize:16,
                        textAlign: "center"
                    });
                    yRenderer.labels.template.setAll({
                        fill: am5.color(0x043c5b),
                        oversizedBehavior: "wrap",
                        maxWidth: 150, fontSize: globalFontSize<16?globalFontSize:16,
                        textAlign: "right"
                    });

                }
                am5plugins_exporting.Exporting.new(root, {
                    menu: am5plugins_exporting.ExportingMenu.new(root, {}),
                    dataSource: data,
                    backgroundColor: am5.color(0xffffff),
                    pdfOptions: {
                        disabled: true
                    },
                    jsonOptions: {
                        disabled: true
                    },
                    csvOptions: {
                        disabled: true
                    },
                    pdfdataOptions: {
                        disabled: true
                    },
                    htmlOptions: {
                        disabled: true
                    },
                    printOptions: {
                        disabled: true
                    }
                });


                series.data.setAll(data);

                yAxisLabels && yAxis.data.setAll(yAxisLabels);

                xAxisLabels && xAxis.data.setAll(xAxisLabels);

                // Make stuff animate on load
                // https://www.amcharts.com/docs/v5/concepts/animations/#Initial_animation
                chart.appear(1000, 100);
            }); // end am5.ready()

        }
    }, [data, tempHeatMap]);// eslint-disable-line

    return <div className="heat-map-chart-maincontainer">
        <div className="heatMapTitleX">{titleX}</div>
        <div className="heatMapTitleY">{titleY}</div>
        <div className="heat-map-chart-container">
            <div id={nameId} style={{ width: width, height: height }} />
            <div className="exportdiv"></div>
        </div>
    </div>
};

export default HeatMapChart;
